import {
  Instance_default
} from "./chunk-GNREHU46.js";
import {
  BaseRoute_default
} from "./chunk-TY443UAN.js";
import {
  env
} from "./chunk-3MLWYAAL.js";

// src/Cmp/CmpRoute.ts
var CmpRoute = class extends BaseRoute_default {
  constructor() {
    super(...arguments);
    this.getConsentsTemplate = (domain, time_start) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: `datastream/template/${domain}${time_start ? "?time_start=" + time_start : ""}`
          },
          false,
          env.REACT_APP_BI_ENDPOINT_URL ?? "https://api.analytics.aesirx.io",
          true
        )
      );
    };
    this.updateConsentsTemplate = (data) => {
      return Instance_default.post(
        this.createRequestURL(
          {
            url: `datastream/template`
          },
          false,
          env.REACT_APP_BI_ENDPOINT_URL ?? "https://api.analytics.aesirx.io",
          true
        ),
        data,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
    };
    this.getUserList = () => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: `datastream/user`
          },
          false,
          env.REACT_APP_BI_ENDPOINT_URL ?? "https://api.analytics.aesirx.io",
          true
        ),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
    };
    this.getUserDetail = (id = 0) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: `datastream/user/${id}`
          },
          false,
          env.REACT_APP_BI_ENDPOINT_URL ?? "https://api.analytics.aesirx.io",
          true
        ),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
    };
    this.createUser = (data) => {
      return Instance_default.post(
        this.createRequestURL(
          {
            url: `datastream/user`
          },
          false,
          env.REACT_APP_BI_ENDPOINT_URL ?? "https://api.analytics.aesirx.io",
          true
        ),
        data,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
    };
    this.updateUser = (data) => {
      return Instance_default.post(
        this.createRequestURL(
          {
            url: `datastream/user`
          },
          false,
          env.REACT_APP_BI_ENDPOINT_URL ?? "https://api.analytics.aesirx.io",
          true
        ),
        data,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
    };
    this.deleteUser = (ids) => {
      return Instance_default.delete(
        this.createRequestURL(
          {
            url: `datastream/user`
          },
          false,
          env.REACT_APP_BI_ENDPOINT_URL ?? "https://api.analytics.aesirx.io",
          true
        ),
        {
          data: { ids: Array.isArray(ids) ? ids : [ids] },
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
    };
  }
};
var CmpRoute_default = CmpRoute;

export {
  CmpRoute_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
